<script>
    import { onMount, onDestroy } from "svelte";
    import * as api from "../utiles/api";
    import * as Common from "../utiles/common.util";
    import * as store from "../stores/store";
    import { push } from "svelte-spa-router";
    import { Capacitor } from "@capacitor/core";
    import { PushNotifications } from "@capacitor/push-notifications";
    import { FCM } from "@capacitor-community/fcm";
    import { get } from "svelte/store";
    import { Preferences } from "@capacitor/preferences";
    import LoginHeader from "../components/LoginHeader.svelte";

    let as_login_id = "";
    let as_password = "";

    onMount(() => {
        // 로그인 상태 체크
        apiGetStatus();

        if (!window.location.href.includes("/Login")) {
            push("/Login");
        }
    });

    async function apiGetStatus() {
        if (Capacitor.isNativePlatform()) {
            const permStatus = await PushNotifications.requestPermissions();

            if (permStatus.receive !== "granted") {
                // alert("푸시 알림 권한이 거부되었습니다.");
                return;
            }
        }

        const token = await Common.getStoredToken();

        if (token) {
            if (location.href.includes("Login")) {
                push("/Home");
            }
        } else {
            if (!location.href.includes("Login")) {
                push("/Login");
            }
        }
    }

    async function login() {
        if (Common.nullCheck(as_login_id, "as_login_id", "아이디")) return;
        if (Common.nullCheck(as_password, "as_password", "비밀번호")) return;

        let fcm_token = get(store.fcm_token);
        if (!fcm_token && Capacitor.isNativePlatform()) {
            try {
                const fcmRes = await FCM.getToken();
                if (fcmRes && fcmRes.token) {
                    fcm_token = fcmRes.token;
                    store.fcm_token.set(fcm_token);
                }
            } catch (err) {
                console.warn("FCM.getToken fallback err:", err);
            }
        }
        if (!fcm_token) {
            const savedFcm = await Preferences.get({ key: "praimas_fcm_token" });
            if (savedFcm && savedFcm.value) {
                fcm_token = savedFcm.value;
                store.fcm_token.set(fcm_token);
            }
        }

        const formData = {
            as_login_id,
            as_password,
            FCM_TOKEN: fcm_token || "",
        };

        const response = await api.post("/account/login", formData);

        if (response != null) {
            store.accountInfo.set(response.data);
            store.jwt_token.set(response.token.accessToken);

            await Preferences.set({
                key: "praimas_jwt_token",
                value: response.token.accessToken,
            });
            await Preferences.set({
                key: "praimas_accountInfo",
                value: JSON.stringify(response.data),
            });

            push("/Home");
        }
    }
</script>

<LoginHeader />

<!-- svelte-ignore a11y-click-events-have-key-events -->
<section class="main inner">
    <div class="mobile">
        <div class="login-img">
            <img src="resource/img/img_login.png" alt="" class="m-login" />
        </div>
        <div class="cmn-title">
            <p>Login</p>
        </div>
        <div class="cmn-input">
            <p>아이디</p>
            <input
                type="text"
                class="as_login_id"
                bind:value={as_login_id}
                on:keypress={(e) => {
                    e.key === "Enter" ? login() : "";
                }}
                placeholder="아이디를 입력해주세요."
            />
        </div>
        <div class="cmn-input" style="margin-top: 20px;">
            <p>비밀번호</p>
            <input
                type="password"
                class="as_password"
                bind:value={as_password}
                on:keypress={(e) => {
                    e.key === "Enter" ? login() : "";
                }}
                placeholder="비밀번호를 입력해주세요."
                maxlength="20"
            />
        </div>

        <div class="cmn-btn">
            <button on:click={login}>Login</button>
        </div>
    </div>
</section>
